import { Link } from 'react-router';

import { Box, Row, Text } from '~/commonComponents';
import { useMediaQuery } from '~/hooks';
import { Colors } from '~/themes/colors';
import { IProfessionalCardRating } from '../../interfaces';
import { ProfessionalRating } from '../ProfessionalRating';

interface IProfessionalNameRowProps {
  id: string;
  fullname: string;
  rating?: IProfessionalCardRating;
  isAvailable?: boolean;
}

export const ProfessionalNameRow = ({
  id,
  fullname,
  rating,
  isAvailable = true,
}: IProfessionalNameRowProps) => {
  const [isLargeScreen] = useMediaQuery(['xl']);

  return (
    <Row alignItems="center" gap={8} style={{ whiteSpace: 'nowrap', minWidth: 0 }}>
      <Text
        bold
        fontSize={20}
        opacity={isAvailable ? 1 : 0.5}
        title={fullname}
        style={{
          display: 'inline-block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          minWidth: 0,
          maxWidth: isLargeScreen ? 500 : 'min(15vw, 500px)',
        }}
      >
        {fullname}
      </Text>

      {rating != null && (
        <Row alignItems="center" gap={8} style={{ flexShrink: 0 }}>
          <ProfessionalRating rating={rating} isAvailable={isAvailable} />

          <Box height={20} width={2} backgroundColor={Colors.neutral_600} />

          {isAvailable ? (
            <Link to={`/dashboard/professional/${id}`} style={{ textDecoration: 'none' }}>
              <Text bold color={Colors.secondary_500} fontSize={18}>
                Profile
              </Text>
            </Link>
          ) : (
            <Text bold color={Colors.secondary_200} fontSize={18}>
              Profile
            </Text>
          )}
        </Row>
      )}
    </Row>
  );
};
